import { FEATURES } from '../constants';
import { Headset, Mail, ShieldCheck } from 'lucide-react';
import styles from './loginStyles';

const SignupDisabled = () => {
  return (
    <div
      id="sign-up-form"
      data-testid="sign-up-form"
      style={{
        width: '360px',
        margin: '0 auto',
        position: 'relative',
        top: '160px',
        backgroundColor: '#fff',
        padding: '32px 28px',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
      }}
    >
      <div style={{ textAlign: 'center', marginBottom: '24px' }}>
        <ShieldCheck
          size={48}
          color={styles.login.form.submit.backgroundColor}
          style={{ margin: '0 auto 16px' }}
        />
        <h2
          style={{
            fontSize: '22px',
            fontWeight: 600,
            color: '#1a1a1a',
            marginBottom: '8px',
          }}
        >
          Managed Access
        </h2>
        <p
          style={{
            fontSize: '14px',
            color: '#6b7280',
            lineHeight: 1.6,
          }}
        >
          To ensure the best experience for our users, account creation is
          managed by our team.
        </p>
      </div>

      <div style={{ marginBottom: '24px' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '12px',
            marginBottom: '16px',
          }}
        >
          <Mail
            size={20}
            color={styles.login.form.submit.backgroundColor}
            style={{ flexShrink: 0, marginTop: '2px' }}
          />
          <p style={{ fontSize: '14px', color: '#4b5563', margin: 0 }}>
            Get in touch and we&apos;ll get your account set up and ready to go.
          </p>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: '12px',
          }}
        >
          <Headset
            size={20}
            color={styles.login.form.submit.backgroundColor}
            style={{ flexShrink: 0, marginTop: '2px' }}
          />
          <p style={{ fontSize: '14px', color: '#4b5563', margin: 0 }}>
            Our team will guide you through the platform every step of the way.
          </p>
        </div>
      </div>

      <div style={{ textAlign: 'center', marginBottom: '24px' }}>
        <a
          href={`mailto:${FEATURES.CONTACT_EMAIL}`}
          style={{
            display: 'block',
            width: '100%',
            padding: '12px 16px',
            backgroundColor: styles.login.form.submit.backgroundColor,
            color: '#fff',
            fontWeight: 600,
            fontSize: '15px',
            borderRadius: '8px',
            textDecoration: 'none',
            textAlign: 'center',
            boxSizing: 'border-box',
            transition: 'opacity 0.2s ease',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.9')}
          onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
        >
          Contact Us to Get Started
        </a>
        <p
          style={{
            fontSize: '12px',
            color: '#9ca3af',
            marginTop: '8px',
          }}
        >
          {FEATURES.CONTACT_EMAIL}
        </p>
      </div>

      <div className="h-rule">
        <hr />
      </div>

      <div
        className="sign-in-link"
        style={{ textAlign: 'center', marginTop: '16px' }}
      >
        Already have an account?{' '}
        <button
          onClick={() => (window.location.href = '/sign-in')}
          style={{
            color: styles.login.form.submit.backgroundColor,
            fontWeight: 500,
            textDecoration: 'underline',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: 'inherit',
          }}
          type="button"
        >
          Sign in
        </button>
      </div>
    </div>
  );
};

export default SignupDisabled;
